import { STATUS_STYLES } from "../constants/announcementOptions";

/** Coloured status pill, driven by STATUS_STYLES. */
export function StatusPill({ status }) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.Submitted;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[13px] font-semibold whitespace-nowrap"
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: style.dot }} />
      {status}
    </span>
  );
}

/** Priority (Important/General) pill. */
export function PriorityPill({ priority, color }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[12px] font-semibold"
      style={{ backgroundColor: `color-mix(in srgb, ${color} 9%, transparent)`, color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />
      {priority}
    </span>
  );
}
